// scenario-dock-prefs.ts
// Per-user localStorage prefs for the scenario grid dock (open state + height).
export const DOCK_OPEN_KEY = 'pf-scenario-dock-open'
export const DOCK_HEIGHT_KEY = 'pf-scenario-dock-height'
export const DEFAULT_DOCK_HEIGHT = 280
export const MIN_DOCK_HEIGHT = 120
export const MAX_DOCK_HEIGHT = 800

export function clampDockHeight(px: number): number {
  return Math.max(MIN_DOCK_HEIGHT, Math.min(MAX_DOCK_HEIGHT, px))
}
export function readDockOpen(): boolean {
  return localStorage.getItem(DOCK_OPEN_KEY) === '1'
}
export function writeDockOpen(open: boolean): void {
  localStorage.setItem(DOCK_OPEN_KEY, open ? '1' : '0')
}
export function readDockHeight(): number {
  const raw = localStorage.getItem(DOCK_HEIGHT_KEY)
  if (raw === null) return DEFAULT_DOCK_HEIGHT
  const n = parseInt(raw, 10)
  if (Number.isNaN(n)) return DEFAULT_DOCK_HEIGHT
  return clampDockHeight(n)
}
export function writeDockHeight(px: number): void {
  localStorage.setItem(DOCK_HEIGHT_KEY, String(clampDockHeight(px)))
}
